import React, { PropTypes } from 'react';
import classNames from 'classnames';
import RTE from 'shared/components/rte/rte.jsx';
import cellHelper from 'main/components/show/cuesheet/cellHelper';

/**
 * Display Changes For Activity Feed Item
 */

// eslint-disable-next-line react/prop-types
const ExpandableListItem = ({ changes, format }) => {
  const inlineStyles = format ? cellHelper.getFormatStyles(format) : null;

  const afListItemClasses = classNames('af-list-item-changes', {
    expanded: changes,
  });

  return (
    <div>
      <div className={afListItemClasses}>
        <div style={inlineStyles} className="af-list-item-changes-content">
          <RTE readOnly rteState={changes} />
        </div>
      </div>
    </div>
  );
};

ExpandableListItem.propTypes = {
  changes: PropTypes.string,
};

export default ExpandableListItem;
